module.exports = __webpack_public_path__ + "static/img/dfzj.a98cb74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/dfzj.jpg
// module id = X2y/
// module chunks = 0